import block from "bem-cn";

import images from "./cloud-error.svg";

import "./ErrorPage.scss";

const cnErrPage = block("ErrorPage");

const ErrorPage = () => {
  return (
    <div className={`${cnErrPage.toString()}`}>
      <div>Извините, кажется, что-то пошло не так.</div>
      <div>Попробуйте позже.</div>

      <img width={500} height={500} src={images} alt="" />
      <div className="footer">
        Если ошибка всё ещё сохраняется долгое время, пожалуйста сообщеите на
        почту: <a href="mailto:belyakov.gy@ssmu.ru">belyakov.gy@ssmu.ru</a>
      </div>
    </div>
  );
};

export default ErrorPage;
